import { Add } from "@mui/icons-material";
import {
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
} from "@mui/material";

import Svg from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export default function GenericModal({
  iconName,
  iconColor,
  iconBgColor,
  title,
  titleColor,
  message,
  buttons = [],
  errorDetails = [],
  expandableError = false,
}) {
  return (
    <div className="flex w-full flex-col gap-4 p-4">
      <div
        className="flex h-60 w-full items-center justify-center"
        style={{ backgroundColor: iconBgColor }}
      >
        <Svg name={iconName} color={iconColor} sx={{ height: "116px", width: "116px" }} />
      </div>
      <div className="w-full">
        <Typography
          className="p-2 text-center text-[32px] font-semibold"
          sx={{ color: titleColor }}
        >
          {title}
        </Typography>
        <Typography className="text-center">{message}</Typography>

        {expandableError && errorDetails.length > 0 && (
          <Accordion className="shadow-none">
            <AccordionSummary
              expandIcon={<Add className="text-sm" sx={{ color: HNSColors.neutrals[300] }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="text-sm underline" sx={{ color: HNSColors.neutrals[300] }}>
                More Error Information
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="h-30 overflow-auto">
                <List sx={{ listStyleType: "disc" }}>
                  {errorDetails.map((errorItem, i) => (
                    <ListItem key={i} sx={{ display: "list-item" }}>
                      <Typography className="text-sm" sx={{ color: HNSColors.neutrals[400] }}>
                        {errorItem}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </div>
            </AccordionDetails>
          </Accordion>
        )}
      </div>

      <div className="flex flex-row justify-between gap-2">
        {buttons.map(({ label, onClick, variant = "contained", sx, disabled = false }, i) => (
          <Button
            key={i}
            variant={variant}
            className="group w-full rounded-full p-4 normal-case"
            sx={sx}
            onClick={onClick}
            disabled={disabled}
          >
            <Typography className="text-sm font-normal group-hover:font-semibold">
              {label}
            </Typography>
          </Button>
        ))}
      </div>
    </div>
  );
}
